import styled from '@emotion/styled';
import { Button } from '@presentation/components';

export const SsoButtonIconWrapper = styled.div`
  margin-right: 12px;
  width: 20px;
  font-size: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const SsoButtonFacebook = styled(Button)`
  background: #3b5998;
`;
